import {AbstractControl, FormControl, ValidationErrors, ValidatorFn} from "@angular/forms";
import {PathwayConstants} from "./pathway.constants";


export const CourseNameValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const name = control.get('name').value;
    const courseId = control.get('courseId').value;

    const nameIsRequired = courseId.length && courseId[0] == PathwayConstants.non_k12_course;

    return nameIsRequired && !name? { courseNameRequired: true } : null;
};
